module.exports = __webpack_public_path__ + "img/suspensionIcon.0c6edf7a.png";